import { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router';
import { FullPageLoader } from '@/components/states';
import { ForbiddenState } from '@/components/states';
import { useAuth } from './AuthProvider';

/** Requires a signed-in user with an active organization (redirects to /login otherwise). */
export function RequireAuth({ children }: { children: ReactNode }) {
  const { status, principal } = useAuth();
  const location = useLocation();
  if (status === 'loading') return <FullPageLoader />;
  if (status === 'anonymous') return <Navigate to="/login" replace state={{ from: location.pathname + location.search }} />;
  if (!principal?.tenant) return <Navigate to={principal?.isPlatformAdmin ? '/platform' : '/select-organization'} replace />;
  return <>{children}</>;
}

/**
 * Route-level permission gate for UX. Pages still handle 403 from the API, because the server is
 * the only authority.
 */
export function RequirePermission({ anyOf, children }: { anyOf: string[]; children: ReactNode }) {
  const { canAny } = useAuth();
  if (!canAny(...anyOf)) return <ForbiddenState />;
  return <>{children}</>;
}
